const parseS3XmlError = (xml: string): { code?: string; message?: string } => {
  const code = xml.match(/<Code>(.*?)<\/Code>/)?.[1];
  const message = xml.match(/<Message>(.*?)<\/Message>/)?.[1];
  return { code, message };
};

export const userMessageForS3Error = (status: number, bodyText: string): string => {
  const isXml = bodyText?.trim()?.startsWith('<?xml') || bodyText?.includes('<Error>');
  const { code = '' } = isXml ? parseS3XmlError(bodyText) : { code: '' };

  if (status === 403 && code === 'InvalidAccessKeyId') {
    return 'Upload service is misconfigured. Please try again later.';
  }
  if (status === 403 && code === 'SignatureDoesNotMatch') {
    return 'Upload authorization expired. Please try again.';
  }
  if (status === 403 && code === 'AccessDenied') {
    return 'You don’t have permission to upload this file.';
  }
  if (status === 413) {
    return 'This file is too large to upload.';
  }
  if (status >= 500) {
    return 'Upload service is temporarily unavailable. Please try again.';
  }

  return 'Upload failed. Please try again.';
};
